export default "__VITE_ASSET__BDB2IXFg__"